import React, { useContext, useState } from 'react';
import { Input, Row, Col } from 'antd';
import { FormContext } from '../metadata/MDForm';
import { AsYouType } from 'libphonenumber-js';
import { getOptionsForAttr } from './coderefs';
import {PortalSelect, PortalSelectOption} from "../PortalSelect";

function formatter(str) {
  if (str.length >= 5) {
    return new AsYouType('US').input(str);
  } else {
    return str;
  }
}

export function PhoneNumberInput({
  phoneNumberAttr,
  phoneNameAttr,
  onChange,
  ...props
}) {
  const formContext = useContext(FormContext);

  const previousPhoneNumberValue = formContext.getValueByAttr(phoneNumberAttr);

  const [phoneNumberValue, setPhoneNumberValue] = useState(
    previousPhoneNumberValue ? previousPhoneNumberValue : ''
  );

  const handlePhoneInput = (e) => {
    const phoneNumber = e.target.value;
    formContext.setValueByAttr(phoneNumberAttr, phoneNumber);
    setPhoneNumberValue(formatter(phoneNumber));
  };

  const metaAttr = formContext.metadata[phoneNameAttr];
  const options = getOptionsForAttr(metaAttr);
  let value = formContext.getValueByAttr(phoneNameAttr);
  if (value === undefined && metaAttr.defaultValue) {
    value = metaAttr.defaultValue;
    formContext.setValueByAttr(phoneNameAttr, value);
  }

  const typeProps = {
    value: value,
    onChange: value => {
      formContext.setValueByAttr(phoneNameAttr, value);
    }
  };

  return (
      <React.Fragment>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <PortalSelect {...typeProps}>
              {
                options.list.map(({value, name}) => <PortalSelectOption value={value}>
                  {name}
                </PortalSelectOption>)
              }
            </PortalSelect>
          </Col>
          <Col span={16}>
            <Input
                id={'primaryPhone'}
                aria-label="Primary phone input"
                value={phoneNumberValue}
                onChange={handlePhoneInput}
                onBlur={onChange}
            />
          </Col>
        </Row>
      </React.Fragment>
  );
}

